import { PipeTransform } from '@angular/core';
var DatePipe = /** @class */ (function () {
    function DatePipe() {
        this.separator = '/';
    }
    DatePipe.prototype.transform = function (val) {
        if (typeof val !== 'string') {
            return val;
        }
        // Formato yyyy-mm-ddThh:ii:ss*
        var _regexpFull = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/i, _regexpShort = /^(\d{4})-(\d{2})-(\d{2})/i, _exec = _regexpFull.exec(val);
        var _ret;
        if (_exec) {
            _ret = _exec[3] + this.separator + _exec[2] + this.separator + _exec[1];
        }
        else {
            var _exec2 = _regexpShort.exec(val);
            _ret = _exec2[3] + this.separator + _exec2[2] + this.separator + _exec2[1];
        }
        return _ret;
    };
    return DatePipe;
}());
export { DatePipe };
